const getHtml = () => {
  return `
    <button type="button" class="btn btn-danger">Danger</button>
    `;
};

const getCss = () => {
  return ``;
};

const getJs = () => {
  return ``;
};

const DangerButton = { getHtml, getCss, getJs };

export default DangerButton;
